import * as types from "../../actions/section/types";

const initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  id: null,
  name: null,
  sectionCount: 0,
  articleCount: 0,
  breadcrumbs: [],
};

export default function section(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SECTION_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_SECTION_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: true,
        id: action.section.id,
        name: action.section.name,
        sectionCount: action.section.section_count,
        articleCount: action.section.article_count,
        breadcrumbs: action.section.breadcrumbs,
      });
    }
    case types.FETCH_SECTION_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }
    case types.MOVE_SECTION_TO_SECTION_REQUEST: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount - 1 });
    }
    case types.MOVE_SECTION_TO_SECTION_FAILURE: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount + 1 });
    }

    case types.MOVE_SECTION_TO_CATEGORY_REQUEST: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount - 1 });
    }

    case types.MOVE_SECTION_TO_CATEGORY_FAILURE: {
      if (!state.isLoaded) {
        return state;
      }
      return Object.assign({}, state, { sectionCount: state.sectionCount + 1 });
    }

    case types.MOVE_ARTICLE_TO_SECTION_REQUEST: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { articleCount: state.articleCount - 1 });
    }
    case types.MOVE_ARTICLE_TO_SECTION_FAILURE: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { articleCount: state.articleCount + 1 });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/section/index.js